<template>
  <div class="layout">
    <Layout>
      <!--侧边栏-->
      <Sider hide-trigger class="sider-body">
        <!-- 账户 -->
        <div class="sider-head">
          <img
            style="width: 42px; height: 42px; border-radius: 50%"
            src="../../static/image/wx_head.jpg"
          />
          西神
        </div>

        <!-- menu body -->
        <div id="menucontainer">
          <div id="menubody" ref="menubody">
            <Menu
              :active-name="openedMenuItem()"
              theme="dark"
              width="auto"
              :open-names="openedMenus"
              accordion
            >
              <Submenu name="1">
                <template slot="title">
                  <Icon type="ios-navigate"></Icon>
                  文档管理
                </template>
                <MenuItem name="1-1" @click.native="doRouter('/html')">
                  前端
                </MenuItem>
                <MenuItem name="1-2" @click.native="doRouter('/php')">
                  后端
                </MenuItem>
                <MenuItem name="1-3" @click.native="doRouter('/mysql')">
                  Mysql
                </MenuItem>
              </Submenu>
              <Submenu name="2">
                <template slot="title">
                  <Icon type="ios-keypad"></Icon>
                  项目统计
                </template>
                <MenuItem name="2-1" @click.native="doRouter('/bill')">
                  票据统计
                </MenuItem>
                <MenuItem name="2-2" @click.native="doRouter('/remark')">
                  备忘统计
                </MenuItem>
              </Submenu>
              <Submenu name="3">
                <template slot="title">
                  <Icon type="ios-book"></Icon>
                  课外宝典
                </template>
                <MenuItem name="3-1" @click.native="doRouter('/chaodai')">
                  朝代管理
                </MenuItem>
                <MenuItem name="3-2" @click.native="doRouter('/icon')">
                  头像管理
                </MenuItem>
                <MenuItem name="3-3" @click.native="doRouter('/author')">
                  诗人管理
                </MenuItem>
                <MenuItem name="3-4" @click.native="doRouter('/shici')">
                  诗词管理
                </MenuItem>
                <MenuItem name="3-5" @click.native="doRouter('/shuf')">
                  轮播管理
                </MenuItem>
                <MenuItem name="3-6" @click.native="doRouter('/category')">
                  分类管理
                </MenuItem>
                <MenuItem name="3-7" @click.native="doRouter('/travel')">
                  景点管理
                </MenuItem>
                <MenuItem name="3-8" @click.native="doRouter('/user')">
                  用户管理
                </MenuItem>
                <MenuItem name="3-9" @click.native="doRouter('/pay')">
                  支付记录
                </MenuItem>
              </Submenu>
              <Submenu name="4">
                <template slot="title">
                  <Icon type="ios-keypad"></Icon>
                  工资统计
                </template>
                <MenuItem name="4-1" @click.native="doRouter('/salary')">
                  工资统计
                </MenuItem>
              </Submenu>
            </Menu>
          </div>
        </div>
      </Sider>

      <Layout>
        <!--顶部 -->
        <Header :style="{ backgroud: '#fff' }">
          <div class="header-body">
            <div class="header-left"></div>
            <div class="header-right">
              <Dropdown trigger="hover" style="margin-left: 20px">
                <a href="javascript:void(0)">
                  个人中心
                  <Icon type="ios-arrow-down"></Icon>
                </a>
                <DropdownMenu slot="list">
                  <DropdownItem>
                    <Icon type="md-person" size="18" color="#515a6e" />{{
                      getName
                    }}
                  </DropdownItem>
                  <DropdownItem @click.native="logout()">
                    <Icon
                      type="ios-log-out"
                      size="18"
                      color="#515a6e"
                    />退出登录</DropdownItem
                  >
                </DropdownMenu>
              </Dropdown>
            </div>
          </div>
        </Header>
        <Content
          :style="{
            padding: '24px',
            background: '#F5F7F9',
            height: '700px',
            overflowY: 'scroll',
          }"
        >
          <router-view></router-view>
        </Content>
        <Footer class="layout-footer-center"
          >2011-2016 &copy; TalkingData</Footer
        >
      </Layout>
    </Layout>
  </div>
</template>
<script>
export default {
  name: "Home",
  data() {
    return {
      menu: [
        {
          menukey: 1,
          menuitemkey: 1,
          path: "/html",
        },
        {
          menukey: 1,
          menuitemkey: 2,
          path: "/php",
        },
        {
          menukey: 1,
          menuitemkey: 3,
          path: "/mysql",
        },
        {
          menukey: 2,
          menuitemkey: 1,
          path: "/bill",
        },
        {
          menukey: 2,
          menuitemkey: 2,
          path: "/remark",
        },
        {
          menukey: 3,
          menuitemkey: 1,
          path: "/chaodai",
        },
        {
          menukey: 3,
          menuitemkey: 2,
          path: "/icon",
        },
        {
          menukey: 3,
          menuitemkey: 3,
          path: "/author",
        },
        {
          menukey: 3,
          menuitemkey: 4,
          path: "/shici",
        },
        {
          menukey: 3,
          menuitemkey: 5,
          path: "/shuf",
        },
        {
          menukey: 3,
          menuitemkey: 6,
          path: "/category",
        },
        {
          menukey: 3,
          menuitemkey: 7,
          path: "/travel",
        },
        {
          menukey: 3,
          menuitemkey: 8,
          path: "/user",
        },
        {
          menukey: 3,
          menuitemkey: 9,
          path: "/pay",
        },
        {
          menukey: 4,
          menuitemkey: 1,
          path: "/salary",
        },
      ],
    };
  },
  methods: {
    openedMenuItem() {
      const path = this.$route.path; // 获取当前路由路径
      var menukey = "1";
      var menuitemkey = "1";
      this.menu.forEach((e) => {
        if (path.startsWith(e.path)) {
          menukey = e.menukey;
          menuitemkey = e.menuitemkey;
        }
      });

      let str = menukey.toString() + "-" + menuitemkey.toString();

      return str;
    },
    logout() {
      sessionStorage.removeItem("token");
      sessionStorage.removeItem("is_login");
      this.$router.push({ name: "Login" });
    },
    doRouter(path) {
      this.$router.push({ path: path });
    },
  },
  mounted() {
    const targetNode = this.$refs.menubody; // 确保你的元素有ref="myElement"
    const resizeObserver = new ResizeObserver((entries) => {});

    resizeObserver.observe(targetNode);
  },
  computed: {
    openedMenus() {
      // 根据当前路由动态设置打开的菜单项，这里只是一个简单示例，你可能需要根据实际情况调整逻辑。
      const path = this.$route.path; // 获取当前路由路径
      var menukey = 1;
      this.menu.forEach((e) => {
        if (path.startsWith(e.path)) {
          menukey = e.menukey;
        }
      });

      return [menukey.toString()];
    },
    getName() {
      return sessionStorage.getItem("name");
    },
  },
  created() {},
};
</script>

<style scoped>
body {
  padding: 0;
  margin: 0;
}
a {
  color: #515a6e;
}
.layout {
  border: 1px solid #d7dde4;
  position: relative;
  border-radius: 4px;
  overflow: hidden;
  border: none !important;
}
.ivu-layout-header {
  background: #fff;
  position: relative;
  z-index: 9;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
}
.layout-nav {
  width: auto;
  margin: 0 auto;
  margin-right: 20px;
}
.layout-footer-center {
  text-align: center;
}
.header-body {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.header-left {
  width: auto;
  height: 100%;
  display: flex;
  align-items: center;
}
.header-right {
  width: auto;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.head-img {
  width: 52px;
  height: 52px;
  border-radius: 50%;
}
.sider-body {
  height: 100vh;
}
.sider-head {
  width: 200px;
  height: 64px;
  background: #2b85e4;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  box-sizing: border-box;
  font-size: 18px;
}
#menucontainer {
  width: 100%;
  height: 90%;
  overflow-x: hidden;
  overflow-y: auto;
  position: relative;
  box-sizing: border-box;
  cursor: pointer;
  z-index: 1000;
}
#menubody {
  width: 100%;
  height: auto;
}
/* 针对Webkit浏览器 */
::-webkit-scrollbar {
  width: 6px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #17233d;
}
</style>



// WEBPACK FOOTER //
// src/views/home.vue